import styled from 'styled-components';

import { H3 } from '~/src/common/components/Typography/layout';

export const Styled = styled(H3)`
  margin: 50px auto;
  text-align: center;
  grid-column: 1 / 3;
`;

interface Props {
  title: string;
}

export const CatalogContentNotFound = (props: Props) => <Styled>{props.title}</Styled>;
